export function getBookingDateRange(maxAdvanceDays: number, now = new Date()) {
  const startDate = new Date(now);
  if (now.getHours() < 5) {
    startDate.setDate(startDate.getDate() - 1);
  }
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(now);
  endDate.setDate(endDate.getDate() + maxAdvanceDays);
  endDate.setHours(23, 59, 59, 999);

  const dates: Date[] = [];
  for (
    const date = new Date(startDate);
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    dates.push(new Date(date));
  }

  return { startDate, endDate, dates };
}
